module.exports = __webpack_public_path__ + "img/to-user-phone.213f5c5e.png";